const checkRequiredFields = (values, requiredFields) => {
  let errorMessage

  requiredFields.some((fieldName) => {
    const isExist = values.includes(fieldName)

    if (!isExist) {
      errorMessage = `payment.beginSubscription() failed. Missed '${fieldName}' value`
      console.error(errorMessage)
    }

    return !isExist
  })

  return errorMessage
}


export default checkRequiredFields
